export default "__VITE_ASSET__CTEkvjM1__"